import styled from 'styled-components';
import { colors } from '../../css';

export const StyledContentDivider = styled.div`
  width: 100%;

  ${(props) => props.position} {
    content: '';
    display: block;
    margin: 0 auto;

    ${(props) => {
      switch (props.theme) {
        case 'hr':
          return `
          width: 100%;
          height: 1px;
          background-color: ${colors.colorGrey04};`;

        case 'default':
        default:
          return `
          width: 57px;
          height: 3px;
          background-color: ${colors.colorBlue};`;
      }
    }}
`;
